<template>
    <div>
        <div style="background: #222222">
            <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/2.png" style="width: 100%;height: auto;display: block" alt="">
        </div>
        <div class="padding-20  background-white ">
            <div class="index-div-content">
                <div class="flex">
                    <div><img width="10" src="/assets/MK体育 - MK(中国)一站式服务官方网站/about/1.png" alt=""></div>
                    <div class="padding-left-20">
                        <div><h2> 广州mk体育智能科技有限公司简介</h2></div>
                        <div><p> Guangzhou MK体育 - MK(中国)一站式服务官方网站 Intelligent Technology Co.,Ltd</p></div>
                    </div>
                </div>
                <div class="margin-top-30 company-content company-img">
                    <h3><span class='content-icon'>▼</span> 公司概况</h3>
                    <p>mk体育智能，创建于2018年10月，现有员工50人，核心团队兼具机器人与传统行业背景。</p>
                    <h3><span class='content-icon'>▼</span> 办公环境</h3>
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/9.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/10.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/11.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/12.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/13.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/14.jpg" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/4.png" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/5.png" width="460" alt="公司照片">
                            </div>
                            <div class="swiper-slide img-info" >
                                <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/about/3.png" width="460" alt="公司照片">
                            </div>
                        </div>
                    </div>
                    <h3><span class='content-icon'>▼</span> 主营产品</h3>
                    <p>专注输送机机器人方向，研发了业内首款输送机专用巡检机器人，面向煤炭、水泥、港口、电厂、钢厂等传统工业场景，实现人工的高危替代与减员增效。</p>
                    <h3><span class='content-icon'>▼</span> 核心壁垒</h3>
                    <p>产品先发优势明显，场景化积累有助于形成极强的准入门槛，同时申请核心专利10项，取得团体标准1项。 </p>
                    <h3><span class='content-icon'>▼</span> 政策支持</h3>
                    <ul>
                        <li>2016年，工信部、发改委、财政部联合印发机器人产业发展规划(2016-2020)，推进机器
                            人在危险程度高的行业广泛应用。</li>
                        <li>2018年，工信部发布高端智能再制造行动计划(2018-2020)，鼓励化工、冶金和电力等
                            行业开展智能服务，推进机器人应用。</li>
                        <li>2019年，国家煤矿安监局发布《煤矿机器人重点研发目录》，明确输送机巡检机器人
                            在煤炭行业的应用。</li>
                        <li>2019年，国务院发表《关于落实&lt;政府工作报告&gt;重点工作部门分工的意见》，要求打造
                            工业互联网平台，拓展“智能+”，推进水泥行业智能化应用。</li>
                        <li class="last-li">输送机巡检机器人应用尚处初期，受政策引导及需求推动输送机机器人市场将高速发展。</li>
                    </ul>
         
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';

    export default {
        name: "electricity",
        data() {
            return {}
        },
        mounted() {
            this.$nextTick(() => {
                new Swiper('.swiper-container', {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop : true,
                    autoplay:true,
                    coverflow: {
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows : true
                    }
                })
            })
        }
    }
</script>

<style scoped lang="scss">
    .member{
        margin-top: 20px;
        h4 {
            font-size: 20px;
            color: #005DAB;
            margin-bottom: 10px;
            text-indent: 22px;
        }
    }
    .member1{
        margin-top: 37px;
    }
    .swiper-container {
        width: 100%;
        padding-top: 50px;
        padding-bottom: 50px;

    }
    .flex{
        margin-bottom: 10px;
    }
    .swiper-slide {
        background-position: center;
        background-size: cover;
        width: 460px;
        height: 345px;

    }

    #hash1{
        .index-el-col-1{
            .img:hover{
                img{
                    transform: scale(1.1);
                }
            }
            .img{
                img{
                    transition: all 0.6s;
                }
            }
        }
    }
    .company-img {


            .img-info:hover{
                img{
                    transform: scale(1.1);
                }
            }
            .img-info{
                overflow:hidden;
                img{
                    transition: all 0.6s;
                }
            }


    }

    h3 {
        font-size: 22px;
        color: #005DAB;
        margin-bottom: 10px;
        .content-icon{
            font-size: 18px;
            display: inline-block;
        }
    }
    h2{
        font-size: 28px;
        color: #005DAB;
        margin-bottom: 10px;
    }

    .company-content {
        p {
            margin-bottom: 30px;
            line-height: 32px;
            text-indent: 22px;
        }

        ul {
            margin-bottom: 30px;
            list-style: none;

            li {
                line-height: 32px;
                text-indent: 22px;
                &.last-li{
                    margin-top: 30px;
                }
            }
        }
    }
    .member{
        p{
            line-height: 24px;
            margin: 0;
        }
    }
    .index-inyong {
        background: url(/assets/MK体育 - MK(中国)一站式服务官方网站/about/1.png) 100% 100% no-repeat;
        background-size: cover;
        height: 400px;
    }



    .flex {
        display: flex;
        justify-items: center;
    }
</style>